import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import * as Validation from "@utilities/validationRules";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import InputEx from "../../../components/wrapperComponents/InputEx";
import moment from "moment";
import InputDate from "../../../components/wrapperComponents/InputDate";
import FormButtons from "../../../components/FormButtons";

interface GeneralitaLavoratoreEditorProps {
    defaultValues: LavoratoreRecord,
    resource: LavoratoreRecord,
    onSubmit: (formData: LavoratoreRecord) => void,
    onCancel: () => void,
    srcFoto: string | null
}

const GeneralitaLavoratoreEditor: React.FC<GeneralitaLavoratoreEditorProps> = ({defaultValues, resource, onSubmit, onCancel, srcFoto}) => {

    const initialValues: LavoratoreRecord = {...defaultValues, ...resource};

    // https://stackoverflow.com/questions/62242657/how-to-change-react-hook-form-defaultvalue-with-useeffect
    const {control, register, watch, getValues, setValue, handleSubmit, reset, formState: {errors}} = useForm<LavoratoreRecord>();
    useEffect(() => {
        reset(initialValues);
    }, [resource]);
    const dtAssunzione = watch('dataAssunzione') as string;

    function onHandleSubmit(newValues: LavoratoreRecord) {
        const format = 'YYYY-MM-DD';
        const formatDate = (date: Date | string | null) => {
            const cData = date as string;
            if (cData && cData.length && cData.length > 0)
                return moment(date, 'DD/MM/YYYY').format(format);
            else if (date && !cData.length)
                return moment(date).format(format);
            return null;
        }
        onSubmit(newValues);
    }

    //const [srcFoto] = useFotoLavoratore(resource);

    const asDate = {date: true, datePattern: ['d', 'm', 'Y']};
    const fotoLavoratore = (<img
        className="h-8 w-auto"
        src="https://tailwindui.com/img/logos/mark.svg?color=blue&shade=600"
        alt="FPNet.HR Powered by ERICED"
    />)
    return <>

        <form onSubmit={handleSubmit(onHandleSubmit)}>
            <div className={'space-y-8 divide-y divide-gray-200'}>
            </div>
            <div className="flex flex-row flex-wrap">
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputEx
                        label={'ID'}
                        name="id"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        readOnly
                    />
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputEx
                        label="Codice Fiscale"
                        name="codiceFiscale"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        readOnly
                    />
                </div>

                {/*
                <div className="pr-4 last:pr-0 ml-auto">
                    {logo}
                </div>
                */}

                <div className="sm:basis-2/4 pr-4 last:pr-0 py-1 flex justify-end">
                    <div className="self-center">{srcFoto && <img src={srcFoto} width="120" className="mt-1 shadow-sm border-2 border-gray-300"/>}</div>
                </div>


                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputEx
                        label="Nome"
                        name="nome"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        readOnly
                    />
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputEx
                        label="Cognome"
                        name="cognome"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        readOnly
                    />
                </div>
                <div className="sm:basis-2/4 pr-4 last:pr-0 py-1"/>
            </div>

            <div className="flex flex-row flex-wrap">
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputEx
                        label="Cod. lavoratore"
                        type="number"
                        name="codDip"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        maxLength={10}
                    />
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputEx
                        label="Cod. lav. paghe"
                        type="number"
                        name="codDipPaghe"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        maxLength={10}
                    />
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputEx
                        label="Matricola"
                        name="matricola"
                        register={register}
                        errors={errors}
                        maxLength={12}
                    />
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1"/>
            </div>

            {/* DATE di ASSUNZIONE/CESSAZIONE/etc. */}
            <div className="flex flex-row flex-wrap">
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <label className="block text-sm font-medium mb-1">Data ass. convenzionale</label>
                    <InputDate
                        name="dataAssConvenzionale"
                        max={dtAssunzione}
                        control={control}/>
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputDate
                        label="Data assunzione"
                        name="dataAssunzione"
                        control={control}
                        readOnly
                    />
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputDate
                        label="Data fine T.Det."
                        name="dataFineTDET"
                        control={control}
                        readOnly
                    />
                </div>
                <div className="sm:basis-1/4 pr-4 last:pr-0 py-1">
                    <InputDate
                        label="Data fine rapporto"
                        name="dataCessazione"
                        control={control}
                        min={dtAssunzione}
                        readOnly
                    />
                </div>
            </div>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>

    </>
        ;
}
export default GeneralitaLavoratoreEditor;
